import ReactGA from "react-ga4";
import Cookies from "js-cookie";
import { MULTI_OFFICE_ID, SINGLE_OFFICE_ID } from "@/common/CommonConstants";
import { GX_ADMIN, UserInfo } from "@/models/auth";

let _userRole: number | undefined;

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId) {
    ReactGA.initialize(measurementId, {gtagOptions: { send_page_view: false } });
  }
};

export const setGAUser = (user?: UserInfo) => {
  _userRole = user?.role;

  if (!ReactGA.isInitialized) {
    return;
  }

  if (user && user.id && (GX_ADMIN !== user.role)) {
    ReactGA.set({ user_id: user.id.toString() });
  } else {
    ReactGA.set({ user_id: undefined });
  }
};

export const trackPageView = (
  path: string
) => {
  console.debug("Tracking page view:", path, " reactGA initialized:", ReactGA.isInitialized);
  if (!ReactGA.isInitialized) {
    return;
  }

  const officeIds = Cookies.get(MULTI_OFFICE_ID);
  const officeId = Cookies.get(SINGLE_OFFICE_ID) || officeIds?.split(',').filter(Boolean)[0];
  
  const pageViewData: any = {
    page_path: path,
    page_location: window.location.href,
    content_group: officeId || undefined,
    office_id: officeId || undefined,
  };

  ReactGA.send({ hitType: "pageview", ...pageViewData });
};

export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  officeId?: string,
) => {
  if (!ReactGA.isInitialized) {
    return;
  }

  ReactGA.event(action, {
    event_category: category,
    event_label: label,
    value,
    content_group: officeId || undefined,
  });
};

export class GoFurtherAnalytics {
  static trackOfficeSelect(officeId?: number, officeName?: string): void {
    if (!ReactGA.isInitialized || _userRole === GX_ADMIN) {
      return;
    }

    ReactGA.event("go_further_select_office", {
      event_category: "GoFurther",
      office_id: officeId ?? undefined,
      office_name: officeName ?? undefined,
    });
  }

  static trackGoChargePlanClick(officeId?: number, officeName?: string): void {
    if (!ReactGA.isInitialized || _userRole === GX_ADMIN) {
      return;
    }

    ReactGA.event("go_further_go_charge_plan_application_click", {
      event_category: "GoFurther",
      office_id: officeId ?? undefined,
      office_name: officeName ?? undefined,
    });
  }

  static trackDriverGuideDownload(officeId?: number, officeName?: string): void {
    if (!ReactGA.isInitialized || _userRole === GX_ADMIN) {
      return;
    }

    ReactGA.event("go_further_driver_guide_download_click", {
      event_category: "GoFurther",
      office_id: officeId ?? undefined,
      office_name: officeName ?? undefined,
    });
  }
}
